import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { PutStoneSettingRequest, StoneSetting } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** Null when the product is not a diamond setting (the backend answers 404). */
export function configuratorQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.configurator(productId),
    queryFn: () => productsApi.getConfigurator(productId),
  });
}

export function useConfigurator(productId: string) {
  return useQuery(configuratorQueryOptions(productId));
}

/** PUT makes the product a setting or replaces its accepted shapes, types and carat range. */
export function useSetConfigurator(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PutStoneSettingRequest) => productsApi.setConfigurator(productId, body),
    onSuccess: (setting: StoneSetting) => {
      queryClient.setQueryData(productKeys.configurator(productId), setting);
    },
  });
}

/** DELETE turns the product back into a plain product. */
export function useRemoveConfigurator(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => productsApi.removeConfigurator(productId),
    onSuccess: () => {
      queryClient.setQueryData(productKeys.configurator(productId), null);
    },
  });
}
